var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideocall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "videocall",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1092",
    "data-name": "Rectangle 1092",
    width: 30,
    height: 30,
    fill: "#6c5b7b",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7",
    "data-name": "Mask Group 7",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-video",
    "data-name": "Icon feather-video",
    transform: "translate(1.586 6.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14349",
    "data-name": "Path 14349",
    d: "M32.59,10.5,24,16.636l8.59,6.136Z",
    transform: "translate(-5.593 -8.046)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14350",
    "data-name": "Path 14350",
    d: "M3.954,7.5h13.5a2.454,2.454,0,0,1,2.454,2.454V22.226a2.454,2.454,0,0,1-2.454,2.454H3.954A2.454,2.454,0,0,1,1.5,22.226V9.954A2.454,2.454,0,0,1,3.954,7.5Z",
    transform: "translate(-1.5 -7.5)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocall);
export default __webpack_public_path__ + "static/media/videocall.3113c3f0a59d44e214b4a21403630f56.svg";
export { ForwardRef as ReactComponent };